import { render, staticRenderFns } from "./base_modal.vue?vue&type=template&id=53165074&scoped=true&"
var script = {}
import style0 from "./base_modal.vue?vue&type=style&index=0&id=53165074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53165074",
  null
  
)

export default component.exports